import { Link } from "react-router-dom";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Images from "../../../common/Images";

const SidebarLogo = (props: any) => {
    const { collapsed, onToggle } = props;
    const ToggleIcon = collapsed ? MenuUnfoldOutlined : MenuFoldOutlined;
    return (
        <div className="gx-layout-sider-header" style={collapsed ? { justifyContent: "center", padding: "10px 0" } : undefined}>
            {!collapsed && (
                <Link to="/" className="site-logo">
                    <img src={Images.logo_white} alt="logo" className="img-logo" />
                </Link>
            )}
            {onToggle && (
                <ToggleIcon
                    onClick={onToggle}
                    style={{ color: "#fff", fontSize: 18, cursor: "pointer" }}
                />
            )}
        </div>
    );
};

export default SidebarLogo;
